import React from 'react';

import { Link } from '@/common/components/link';
import { DistributiveOmit } from '@/common/types';

export function isLinkProps(props: any): props is DistributiveOmit<React.ComponentPropsWithoutRef<typeof Link>, 'className'> {
  return 'href' in props || 'to' in props;
}

export type ExtractLinkProps<AdditionalOmit extends string = never> = DistributiveOmit<
  React.ComponentPropsWithoutRef<typeof Link>,
  'className' | AdditionalOmit
>;
